export { renderSchematic, type SchematicHandles } from './renderer';
